module.exports = __webpack_public_path__ + "img/styletrue.8305ac50.png";